'use strict';

/** @type {import('./isObject')} */
module.exports = function isObject(x) {
	return !!x && (typeof x === 'function' || typeof x === 'object');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-object-atoms/isObject.js
 ** module id = 71
 ** module chunks = 0
 **/